module.exports = __webpack_public_path__ + "img/ischool_logo.afdfb4a0.svg";